export const debounce =
  (fn: any, delay: any, timeout: any = null) =>
  (args: any) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => fn(args), delay);
  };
